import { createSlice } from "@reduxjs/toolkit";
import { act } from "react-dom/test-utils";
import PatientDetails from "../../pages/PatientDetails";

// prevent everytime login
// its for demo purpose
// const defaultLoginData = {
//   delivery_partner_id: "A9D9D8A7-E9FA-4F79-B644-7555082989F0",
//   id: "A2955D12-898D-419D-A5C8-D948DB26F78E",
//   mobile_no: "9712313293",
//   name: "Vihas Mac",
//   token:
//     "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyX2lkIjoiQTI5NTVEMTItODk4RC00MTlELUE1QzgtRDk0OERCMjZGNzhFIiwiZGVsaXZlcnlfcGFydG5lcl9pZCI6IkE5RDlEOEE3LUU5RkEtNEY3OS1CNjQ0LTc1NTUwODI5ODlGMCIsImlhdCI6MTY2NDczMzA0MSwiZXhwIjoxNjY3MzI1MDQxfQ.sXcRU2j4HvYvQzb-GfsMYgRBjxiIOVMO1mTM1ZfhH6Y",
// };

const initialState = {
  apiData: "",
  isLoggedIn: false,
  mobileNo: "",
  PatientDetails: [],
  eProcode: "",
};

const authSlice = createSlice({
  name: "authReducer",
  initialState,
  reducers: {
    // changeAuthStep: (state, action) => {
    //   state.step = action.payload;
    // },
    // setOtpData: (state, action) => {
    //   state.otpId = action.payload.id;
    //   state.phoneNumber = action.payload.mobile_no;
    // },
    setLoginData: (state, action) => {
      const { ...restPayload } = action.payload;
      return {
        ...state,
        ...restPayload,
        // otpId: null,
        // step: null,
        isLoggedIn: true,
      };
    },
    setApiData: (state, action) => {
      state.apiData = action.payload;
    },
    setMobileNo: (state, action) => {
      state.mobileNo = action.payload;
    },
    setTokenStatus: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setPatientData: (state, action) => {
      state.PatientDetails = action.payload;
    },
    setEProcode: (state, action) => {
      state.eProcode = action.payload;
    },
  },
});

export const {
  setLoginData,
  setApiData,
  setTokenStatus,
  setMobileNo,
  setPatientData,
  setEProcode,
} = authSlice.actions;
export default authSlice.reducer;
